export const MENU_TRANSITION_TIMEOUT_MS = 100;
export const FOCUS_CLASSES = ['cdk-focused', 'cdk-program-focused'];
